import React from 'react';
import ProjectCard from './ProjectCard';

const TAPE_POSITIONS = ['top-left', 'top-center', 'top-right'];

/*
  Página de categoria do portfólio. As três categorias (Fashion Film, Rede Social,
  Comercial e Outros) usam exatamente o mesmo layout — só mudam o ícone, os textos,
  a cor da fita e a densidade da grade. Manter isso num componente só facilita o
  suporte futuro (adicionar/remover vídeo é mexer só no mock.js).
*/
const CategoryPage = ({
  icon: Icon,
  title,
  subtitle,
  projects,
  tapeColor = 'rgba(210,190,130,0.42)',
  tapeSide = 'left',
  quote,
}) => {
  // Com poucos vídeos a grade encolhe em vez de deixar um vão à direita.
  const colunas = Math.min(projects.length, 3);

  return (
    <div style={{ backgroundColor: '#f7f5ef', minHeight: '100vh' }}>
      {/* Cabeçalho da página */}
      <section
        style={{
          backgroundColor: '#f7f5ef',
          padding: 'clamp(3.5rem, 6vw, 5.5rem) clamp(1.5rem, 5vw, 5rem) 3rem',
          borderBottom: '1px solid rgba(0,0,0,0.05)',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* Fita decorativa */}
        <div
          style={{
            position: 'absolute',
            top: '2.5rem',
            [tapeSide]: 'clamp(1.5rem, 5vw, 5rem)',
            width: '100px',
            height: '16px',
            background: tapeColor,
            borderRadius: '2px',
            transform: `rotate(${tapeSide === 'left' ? '-1.2' : '1.5'}deg)`,
          }}
        />

        <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem', marginBottom: '1.2rem' }}>
            <Icon size={22} style={{ color: '#a09070', marginTop: '4px', flexShrink: 0 }} />
            <div>
              <p
                style={{
                  fontFamily: '"Nunito", sans-serif',
                  fontSize: '9.5px',
                  letterSpacing: '0.32em',
                  color: '#a09070',
                  margin: '0 0 0.6rem',
                  textTransform: 'uppercase',
                }}
              >
                PORTFÓLIO
              </p>
              <h1
                style={{
                  fontFamily: '"Cormorant Garamond", "Georgia", serif',
                  fontSize: 'clamp(2.2rem, 5vw, 3.8rem)',
                  color: '#1a1a1a',
                  margin: '0 0 0.8rem',
                  fontWeight: 600,
                  lineHeight: 1.1,
                }}
              >
                {title}
              </h1>
              <p
                style={{
                  fontFamily: '"Nunito", sans-serif',
                  fontSize: 'clamp(14px, 1.4vw, 15.5px)',
                  color: '#6a6a6a',
                  maxWidth: '600px',
                  lineHeight: 1.75,
                  margin: 0,
                }}
              >
                {subtitle}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Faixa de citação (opcional) */}
      {quote && (
        <div
          style={{
            backgroundColor: '#1a1a1a',
            padding: '1.8rem clamp(1.5rem, 5vw, 5rem)',
            textAlign: 'center',
          }}
        >
          <p
            style={{
              fontFamily: '"Cormorant Garamond", "Georgia", serif',
              fontSize: 'clamp(1.1rem, 2.2vw, 1.5rem)',
              color: 'rgba(247,245,239,0.85)',
              margin: '0 auto',
              fontStyle: 'italic',
              maxWidth: '800px',
              lineHeight: 1.6,
            }}
          >
            {quote}
          </p>
        </div>
      )}

      {/* Grade de projetos */}
      <section style={{ padding: 'clamp(3rem, 6vw, 5rem) clamp(1.5rem, 5vw, 5rem)' }}>
        <div style={{ maxWidth: colunas === 3 ? '1100px' : `${colunas * 340}px`, margin: '0 auto' }}>
          <div
            className="projects-grid"
            style={{ gridTemplateColumns: `repeat(${colunas}, 1fr)` }}
          >
            {projects.map((project, i) => (
              <ProjectCard
                key={project.id}
                {...project}
                tapePosition={TAPE_POSITIONS[i % TAPE_POSITIONS.length]}
              />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default CategoryPage;
